export class Championship {
    public constructor () {
        this.ChampionshipId = 0;
        this.Name = "";
        this.SubscriptionStatus = 2;
        this.Status = 2;
        this.IsDefault = false;
    }
    ChampionshipId: number;
    Name: string;
    SubscriptionStatus: number;
    Status: number;
    IsDefault: boolean;
    Price: number;
}


// WEBPACK FOOTER //
// ./src/entities/championship.ts